import type { FooterLink } from '../../../../../types';

export default [
  {
    name: 'Security & Privacy',
    href: '/security-privacy/employer',
    rel: 'nofollow',
    analytics: 'navigation_pressed',
    linkText: 'privacy',
    experience: 'candidate',
  },
  {
    name: 'Terms & Conditions',
    href: '/support/termsconditions',
    rel: 'nofollow',
    analytics: 'navigation_pressed',
    linkText: 'terms & conditions',
  },
  {
    name: 'Protect yourself online',
    href: '/protect-yourself-online',
    rel: 'nofollow',
    analytics: 'navigation_pressed',
    linkText: 'protect yourself online',
  },
  {
    name: 'Contact',
    href: '/contactus',
    rel: 'nofollow',
    analytics: 'navigation_pressed',
    linkText: 'contact us',
  },
] as FooterLink[];
